export default "__VITE_ASSET__BzyXejmf__"